module.exports = __webpack_public_path__ + "static/media/OCFL-Alert-App-Page.23cd9105.png";